<template>
  <FormSection title="Supportive Information">
    <div class="supportive-info">
      <div v-for="ans in supportiveAnswers" :key="`ANS1_${ans.ID}`" class="info-item">
        <label v-text="ans.APFQ_Desc"></label>
        <textarea class="form-control" v-model="ans.APFA_Answer" readonly rows="3" />
        <textarea
          v-if="ans.APFA_Answer === 'yes' && ans.APFA_AnswerValue"
          class="form-control additional-info"
          rows="3"
          v-text="ans.APFA_AnswerValue"
          readonly
        />
      </div>

      <template v-if="!isPreschool && additionalQuestionAnswers.length > 0">
        <h6 class="additional-title">Additional Information</h6>
        <div v-for="ans in additionalQuestionAnswers" :key="`ANS2_${ans.ID}`" class="info-item">
          <label v-text="ans.APFQ_Desc"></label>
          <input class="form-control" type="text" v-model="ans.APFA_Answer" readonly />
        </div>
      </template>
    </div>
  </FormSection>
</template>

<script>
import FormSection from './FormSection.vue'

export default {
  name: 'SupportiveInformationSection',
  components: {
    FormSection,
  },
  props: {
    answers: {
      type: Array,
      default: () => [],
    },
    isPreschool: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    supportiveAnswers() {
      return this.answers.filter(a => a.APFA_Answer && a.APFQ_Ordering <= 25)
    },
    additionalQuestionAnswers() {
      return this.answers.filter(a => a.APFA_Answer && a.APFQ_Ordering > 25)
    },
  },
}
</script>

<style scoped>
.supportive-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-item label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-control {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: #f8f9fa;
  resize: vertical;
}

.additional-info {
  margin-top: 10px;
  background-color: #e9ecef;
}

.additional-title {
  color: #333;
  font-weight: 600;
  border-bottom: 2px solid #426dff;
}
</style>
